import { EssSection } from '@/domain/impact-ess/entities/question.entity';
import { ModelVersionESS } from '@/domain/project/entities/project.entity';
import { ESSQuiz } from '@/ui/pages/app/components/quiz-panel/ess/ESSQuiz';

interface IProps {
  essQuizLayout: Record<string, { sections: Array<EssSection> }>;
  dateId: number;
  modelESS: ModelVersionESS;
}

export function ESSDayQuiz({ essQuizLayout, dateId, modelESS }: IProps) {
  return (
    <ESSQuiz
      essQuizLayout={essQuizLayout}
      displayTopicPicker={false}
      dateId={dateId}
      modelESS={modelESS}
      useSectionTitleSeparators={true}
      displayValidationButtons
    />
  );
}
